import React, { useState, useEffect } from "react";

const Countdown = ({ value, onFinish }) => {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Calculate initial seconds remaining from timestamp
    return value > Date.now() ? Math.round((value - Date.now()) / 1000) : 0;
  });

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(remainingSeconds).padStart(2, "0");

    return `${formattedMinutes}:${formattedSeconds}`;
  };

  useEffect(() => {
    // Update timeLeft when value prop changes
    setTimeLeft(
      value > Date.now() ? Math.round((value - Date.now()) / 1000) : 0,
    );
  }, [value]);

  useEffect(() => {
    if (timeLeft <= 0) {
      if (onFinish) {
        onFinish();
        localStorage.removeItem("countdown");
      }
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft, onFinish]);

  return <p>{formatTime(timeLeft)}</p>;
};

export default Countdown;
